import { type OmitPageParam, usePagination } from '~/composables/usePagination'
import { getReputationListApi } from '@/server'
import type { ReputationParams, ReputationResponse } from '~/server/types'

export function logicReputationList() {
  const data = ref<ReputationResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '口碑筛选列表',
    request: async (pageParams, params?: OmitPageParam<ReputationParams>) => getReputationListApi({ ...(params || {}), ...pageParams }),
  })

  async function getPage(page: number | string = 1, params: OmitPageParam<ReputationParams>) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value = list
  }
  return {
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}
